export const lang = {
    index: {
        mz: '媽祖信仰與泉州天后宮',
        ct: '傳統建築設計與構造教學',
        mn: '閩南僑鄉傳統修繕訓練',
        kh: '考核測試',
        sy: '實驗報告',
        exper_header: {
            backButton: '返回'
        }
    },
    mz: {
        score: '當前得分',
        one: {
            zs: '知識學習',
            wt: '問題思考',
            wt_child: {
                title: '思考題',
                js: '【請簡述泉州天后宮在媽祖信仰傳播中的作用】',
                sub: '提交'
            }
        },
        two: {
            dl: '地理區位',
            cj: '創建歷史',
            cj_child: {
                title: "【天后宮的創建】",
                content: '史料記載，泉州天後宮始建於宋慶元二年(1196年)。傳說其年，「泉州浯浦海潮庵僧覺全夢神命作宮，乃推裏人徐世昌倡建。實當浯江巽水二流之匯，番舶客航聚集之地。時，羅城尚在鎮南橋內，而是宮適臨浯浦之上。」 當時建的這座媽祖宮規模已經很大，有三殿、山門、兩廊、兩亭。以宋徽宗宣和四年(1122年)賜額「順濟」，稱為順濟宮。「順濟」者，即順風以濟之意。宋元時期，泉州與埃及的亞歷山大港齊名，是世界上最大的兩個貿易商港之一，與亞洲五十八年國家和地區有貿易往來。同時，泉州的造船業也著稱於世，國家出海貿易的船舶「多廣州、泉州所造。」宋代，泉州地方長官和市舶司官員，每年春秋兩季都舉行「祈風」、「祭海」儀式，祈求風浪平青靜，航海平安，以鼓勵發展對外貿易。 最初祭海在晉江邊的真武廟，祈風儀式在南安縣的九日山，但到了南宋未年，取而代之的是順濟宮的祭儀。宋元明歷朝經常遣官致祭，清康熙五十九年(1720年)欽定春秋兩祭，此後，順濟宮官祭便成定例。 　　泉州順濟宮建後十五年，南宋嘉定四年(1211年)郡守鄒應龍於筍江下流造石橋，以近順濟宮，因名「順濟橋」。石橋位於順濟宮前，橫跨晉江，全長一百五十余丈，寬一點五丈，橋上有石欄桿、塔幢，橋頭有威武的石將軍、橋堡，橫匾上書「雄鎮天南」四字，橋中石刻「順濟橋」三字。中外商船泊於岸邊江中，首先看見的就是順濟宮和順濟橋這兩座雄偉的建築，「順濟」、「媽祖」之名隨之四海傳揚。',
                next: '下一页'
            },
            kj: '空間佈局',
            ll: '理論測試',
            questions: {
                first: {
                    question: '1.天后宮建築群中軸線前後順序是什麼？',
                    options: {
                        A: 'A.山門、天后殿、寢殿、梳妝樓',
                        B: 'B.天后殿、山門、寢殿、梳妝樓',
                        C: 'C.山門、寢殿、天后殿、梳妝樓',
                        D: 'D.山門、天后殿、梳妝樓、寢殿'
                    }
                },
                second: {
                    question: '2.下列建築群，具有與泉州天后宮相似的空間序列的是？',
                    options: {
                        A: 'A.鼓浪嶼菽莊花園',
                        B: 'B.漳州文廟',
                        C: 'C.南靖土樓永定樓',
                        D: 'D.泉州泉港區小三房古厝'
                    }
                },
                title: '單選題',
                determine: '確定',
                NextQ: '下一題',
                tipSuccess: '答對了！',
                tipError: '答錯了！',
                over: '理論測試已結束，本次測試成績：',
                NextInteraction: '請點擊進入交互訓練！'
            }
        }
    },
    ct: {
        one: {
            zs: '知識學習',
            ll: '理論測試',
            jh: '交互訓練',
            ll_child: {
                firstQ: {
                    question: '1.下列材料不屬於閩南傳統建築材料的是？',
                    options: {
                        A: 'A.煙炙磚',
                        B: 'B.杉木',
                        C: 'C.海蠣殼灰',
                        D: 'D.水泥'
                    }
                },
                secondQ: {
                    question: '2.下列對閩南特有的煙炙磚的說明錯誤的是？',
                    options: {
                        A: 'A.煙炙磚又稱為胭脂磚',
                        B: 'B.煙炙磚是我國古代青磚的一種',
                        C: 'C.煙炙磚是閩南地區特色建築材料，它是紅磚的一種',
                        D: 'D.煙炙磚是在燒製過程中，松枝灰落在磚坯相疊的露空部位，熏出黑色斜紋而形成的'
                    }
                },
                thirdQ: {
                    question: '3.在閩南，“出磚入石”是牆面的一種藝術表現形式，其含義指的是？',
                    options: {
                        A: 'A.砌牆時，磚砌在石頭基礎的上面',
                        B: 'B.砌牆時，磚作為外牆材料，石材作為內牆材料',
                        C: 'C.砌牆時，磚與大小不一的石材混用，形成極具變化的牆體',
                        D: 'D.牆體中，磚要突出於石材'
                    }
                },
                fourthQ: {
                    question: '4.閩南古代傳統建築中，室內地面不會採用的材料為？',
                    options: {
                        A: 'A.紅色鬥底磚',
                        B: 'B.木板條',
                        C: 'C.條石',
                        D: 'D.水磨石'
                    }
                }
            },

        },
        two: {
            one: {
                zs: '知識學習',
                ll: '理論測試',
                jh: '交互訓練',
                zs_child: {
                    first: {
                        title: '1.中國古代屋頂形式',
                        content: '中國古代建築的屋頂對建築立面起著特別重要的作用。他那遠遠伸出的屋簷、富有彈性的屋簷曲線、由舉架形成的稍有反曲的屋面、微微起翹的屋角（仰視屋角，角椽展開猶如鳥翅，故稱“翼角”）以及硬山、懸山、歇山、廡殿、攢尖、十字脊、盝頂、重簷等眾多屋頂形式的變化，加上燦爛奪目的琉璃瓦，使建築物產生獨特而強烈的視覺效果和藝術感染力。通過對屋頂進行種種組合，又使建築物的體形和輪廓線變得愈加豐富。而從高空俯視，屋頂效果更好，也就是說中國建築的“第五立面”是最具魅力的。'
                    },
                    second: {
                        title: '2.天后殿：重簷歇山頂',
                        content: '歇山頂，即歇山式屋頂，宋朝稱九脊殿、曹殿或廈兩頭造，清朝改今稱，又名九脊頂。為中國古建築屋頂樣式之一，在規格上僅次於廡殿頂。所謂重簷，是在屋簷下又加了一層屋簷，形成兩層屋簷的形式。'
                    },
                    third: {
                        title: '3.東西廊、寢殿：硬山頂',
                        content: '硬山式屋頂是中國傳統建築雙坡屋頂形式之一。房屋的兩側山牆同屋面齊平或略高出屋面。 屋面以中间横向正脊为界分前后两面坡，左右两面山墙或与屋面平齐，或高出屋面。高出的山墙称封火山墙，其主要作用是防止火灾发生时，火势顺房蔓延。然而从外形看也颇具风格。'
                    },
                    fourth: {
                        title: '4.屋面構造'
                    }
                },
                ll_child: {
                    first: {
                        question: '1.泉州天后宮寢殿的屋頂形式為？',
                        options: {
                            A: 'A.硬山',
                            B: 'B.懸山',
                            C: 'C.重簷廡殿',
                            D: 'D.歇山'
                        }
                    },
                    second: {
                        question: '2.泉州天后宮天后殿的屋頂形式為？',
                        options: {
                            A: 'A.歇山',
                            B: 'B.重簷歇山',
                            C: 'C.硬山',
                            D: 'D.捲棚'
                        }
                    }
                }
            },
            two: {
                zs: '知識學習',
                ll: '理論測試',
                jh: '交互訓練',
                zs_child: {
                    first: {
                        title: '1、閩南結構形式特點',
                        line1: '中國南方浙、閩、粵等地民間一些重要的建築或一座建築中主要的構架，常使用一種兼具抬樑式與穿斗式構架特點的混合構架，有人稱之為“插樑式構架”。',
                        line2: '插樑式構架的特點是,承重樑的兩端插入柱身,與抬樑式構架的承重梁壓在柱頭上不同，與穿斗式構架的以柱直接承槐、柱間無承重梁、僅有拉接用 的穿榜的形式也不同。具體地講，即組成屋面的每根橡條下皆有一柱（前後檐柱、金柱、童柱或中柱），每一童柱騎在下面的樑上，而梁端則插入柱身。最下端的大樑兩端插入前後金柱柱身，這種結構一般都有前廊步或後廊步,并用多重丁头棋的方式加大出檐,在纵向上，也以插入柱身的联系梁（寿梁或楣、彷）相连。这种构架与抬梁式一样，在文献、工艺及匠师中并没有专门的称渭。',
                        line3: '插樑式構架兼有抬樑與穿鬥的特點,它主要以承重梁傳遞荷載,這是抬樑的原則；而橡條直接壓在柱頭上，童柱騎在下面的樑上，又有穿鬥的特點，但它一般沒有通長的穿過柱身的穿楊,其施工方式也與抬樑式構架相似,是現場施工、由下而上、分件組裝而成穿斗式構架則是一根排架在地面上組裝好，然後整體立起，臨時支俵到位，再用縱向穿楊將各福屋架相連插樑式構架的山面往往加設通商的中柱，以增加剛度。',
                        line4: '從構架的穩定性來看,插樑式構架顯然優於抬樑式構架,因為它的樑頭插入柱身,有多層次的樑柱間插柳，有的還在大樑下另加一道隨梁楊以增加穩定性。從承重來看，它的梁跨大於穿斗式，空間開敞，但它的步架又比抬樑式要小。從用料看，它的樑柱粗壯，尤其是大樑，採用近似圓形的斷面,是穩定可靠的。'
                    },
                    second: {
                        title: '2、寢殿木構架'
                    },
                    third: {
                        title: '3、樑架構件',
                        type1: {
                            exp: '柱：',
                            exp_title: '對於不同位置上的柱子，閩南工匠有以下幾種稱呼：',
                            line1: '(1)位於前後檐的檐柱，稱為“步柱”、“部柱”、“步口柱”，即通稱的檐柱。',
                            line2: '(2)步柱以內的金柱稱“青柱”，有“小青柱”、“前青柱”、“後青柱”之分。',
                            line3: '(3)廟宇、祠堂明間的四根內柱，稱為“四點金柱”。在四點金柱前後的柱子都稱為“付點”或“副點”柱，意為次要的柱子。',
                            line4: '(4)與山牆結合的柱子稱為“平柱”又稱“附壁柱”。',
                            line5: '(5)支承脊檁的中柱或山柱稱“脊柱”，民居之中較多使用。祠堂、廟宇之中，除明間外，其他幾縫尤其是山面的樑架多用脊柱，以保持構架的整體穩定。'
                        },
                        type2: {
                            exp: '通梁：',
                            line1: '閩南稱梁為“通”、“通梁”。通梁之中，最長、最大、位置最低的一根，稱為“大通”，大約即唐宋時期的“通栿”。大通之上的梁，由下而上依次稱為“二通”、“三通”。大通一般長達4個或6個步架，插在前後金柱間，這個位置稱為“架內”，其上立瓜筒（或疊鬥、獅座等）承托二通，二通較大通短兩個步架，斷面尺寸亦略小些，二通之上再立瓜筒（或疊鬥）承托三通，三通中央置瓜筒（或疊鬥）承托脊檁。這是前後金柱之間的架內的通梁，架內前後的大方位置的通梁稱步通。步通位於檐柱（步柱）與金柱（青柱）之間，內端插入青柱,外端穿過步柱或疊鬥承托寮圓，長度通常只有兩三個步架。',
                            line2: '通梁之中，大通用料最大，與中脊楹（脊檁）直徑相當；二通小於大通約1寸；三通又略小於二通；步通與二通相當。通樑上瓜筒的直徑又略大於通梁，以便使瓜腳騎於通樑上。',
                            line3: '通樑的斷面有三種：第一種為矩形，用於次間或次要建築的構架中。第二種作高狹的六角形，即在矩形樑的側面中間凸出鋒線，在漳州地區使用較多。第三種使用最為廣泛，通梁側面呈琴面狀，梁身十分飽滿，稱為“肥通”。第三種樑與宋代以來江南流行的月梁相似，但梁兩肩一般無卷殺，梁底中間也不內䫜。其側面兩端入柱處有捲殺，以便過渡成矩形榫頭插入柱身或疊鬥之中，並且順勢在側面刻出呈側臥狀的“人”字或“八”字形的曲線，閩南工匠稱這種曲線為“魚尾叉”，魚尾叉線內的三角形塊面又向內凹入。',
                        },
                        type3: {
                            exp: '瓜桶：',
                            line1: '樑上的矮柱，古稱侏儒柱。 《營造法式》卷五“大木作制度•侏儒柱”說：“侏儒柱，其名有六：一曰棁、二曰侏儒柱、三曰浮柱、四日棳、五日楹、六日蜀柱。“棁、棳皆音拙。棁、浮、棳、蜀疑皆是“侏儒”二字的急讀合音。,外端穿过步柱或叠斗承托寮圆，长度通常只有两三个步架。',
                            line2: '北方官式建築中，承托樑的矮柱有童柱、瓜柱、坨橔等。清式的脊瓜柱柱徑較小。僅為三架梁厚的4/5。明代的瓜柱，其直徑相當於對應的金柱柱頭尺寸。由於直徑較大，立於樑上時，兩側寬於梁身厚，於是往往採用騎栿的做法，除瓜柱根部居中做榫外，兩側還作插肩夾皮榫騎於梁背上。',
                            line3: '江南地區的童柱，柱徑上細下粗，收殺很大，與柱交接處用騎栿做法。南方地區明清建築另有一種極為誇張的粗矮童柱。童柱與梁交接處寬於梁背，柱腳伸出包住圓作梁。柱腳包樑的形式表現出不同的地域特徵。蘇南為一段弧形或海棠葉弧形，比較簡單，不作雕刻。浙北及浙東多為出一葉尖鋒的鷹嘴形，稱“鷹爪”、“鷹嘴”，浙南則為出多葉尖鋒的爪形或多瓣的南瓜葉形。',
                            line4: '闽南称这种童柱为“瓜筒”、“木瓜筒”、“筒仔”。瓜筒立在通梁上承托二通、三通及楹仔，断面呈圆形、椭圆形或瓜瓣形。明代以前还使用截面多为瓜瓣形且略呈梭形的蜀柱，如泰宁甘露庵蜃阁【南宋绍兴十六年（1146）】、晋江市青阳庄用宾故居（明代）、漳州市台湾路“两台秉宪、六代承恩”残石坊（明代）、新华东路的“勇壮简易、所向无前”坊（1707）、“闽越雄声、楚滇伟绩”坊（1722）、晋江市衙口靖海侯府（清代初期）等所见。'
                        },
                        type4: {
                            exp: '帥槓：',
                            line1: '角梁是廡殿、歇山、攢尖、廊廡等轉角處承托簷椽、飛椽及角脊的關鍵構件。泉州市開元寺南宋雙石塔中，大角樑頭形狀與昂頭相似，與角昂相距較近，且其下不用角神或寶藏神 ，外觀幾乎與“由昂”相近；子角梁則斜插在大角梁背上，起翅頗多，與江南明清建築的“嫩戧發戧”做法十分相近。石獅市姑嫂塔(1131—1162)、泉州市清源山彌陀岩石殿(1364)、瑞像岩石殿(1483)等宋元石構仿木建築中，角梁做法與開元寺雙石塔相似，子角梁插於大角梁背上，兩者之夾角在130°左右。',
                        },
                        type5: {
                            exp: '燈梁：',
                            line1: '燈梁，也稱燈桿，一般安置在正廳明間脊檁（脊圓）與前坡下金檁（下副圓）之間的通梁背上。如果是廟宇、祠堂的五架坐樑式構架，燈樑架於大通的背上；民居則置於一郎或二郎背上，兩端或有雕花“燈座”承托；若為“擱檁造”，燈座則插入嵌於牆壁的燈座上。對於房屋的屋架而言，燈梁沒有結構上的作用，僅作大厝、祠堂、廟宇懸掛燈籠之用。 ，外觀幾乎與“由昂”相近；子角梁則斜插在大角梁背上，起翅頗多，與江南明清建築的“嫩戧發戧”做法十分相近。石獅市姑嫂塔(1131—1162)、泉州市清源山彌陀岩石殿(1364)、瑞像岩石殿(1483)等宋元石構仿木建築中，角梁做法與開元寺雙石塔相似，子角梁插於大角梁背上，兩者之夾角在130°左右。',
                            line2: '燈樑的斷面呈六角形，閩南工匠以“九五分六角”的方法做出。即在一根直徑9份的圓木上，取直徑中段5份，上下延伸與圓周相交，得出六角形的上下邊，再分別與直徑兩端相連，連接成六角形。這種分割方法，與《營造法式》卷二“總例”計算正六邊形的公式“六棱徑八十有七，每面五十，其斜一百”不同。直徑9份的圓木的內接六邊形，其上下邊的邊長為5份，得出的是一個形狀稍扁的六邊形。閩南大木工匠都掌握“九五分六角”這一技術，因為每一幢建築的大廳都有一根這種斷面六角形的燈梁，燈梁之上繪滿以紅色調為主的包巾彩畫，是屋架之中 最為華麗的構件。即使房屋不施彩畫.燈梁也必 須繪滿彩畫。'
                        },
                        type6: {
                            exp: '壽梁：',
                            line1: '壽梁，指步口柱（檐柱）之間的與檁條平行的“闌額”，也寫作“受梁”。',
                            line2: '壽梁是檐柱間的額枋，位置显著。福建宋代建築中的闌額有兩種。一種是以福州市華林寺大殿正面外檐為代表的“月樑式”，闌額兩肩卷殺，側面的琴面飽滿，入柱處無斜項，底面略有內䫜；另一種是莆田市玄妙觀三清殿、泰宁縣甘露庵諸殿閣的直樑式，斷面呈矩形。',
                            line3: '閩南的壽梁，以第一種月樑式發展而來的最為常見，其斷面尺寸較大，一般呈卵蛋形，但頂面與底面削平，側面的琴面十分飽滿，兩端入柱處有捲殺，並刻有魚尾叉，在卷殺等工藝處理上與通梁相似。泉州市開元寺南宋鎮國塔與仁壽塔上的闌額，正面作琴面狀，兩端入柱處作兩道魚尾叉狀曲線，但叉內不凹入；在泉州明代文廟大成殿與明倫堂、泉州清源山瑞像岩中，壽樑的魚尾叉曲線內凹入，清代建築都做成這種凹入的形式。'
                        },
                        type7: {
                            exp: '束仔、束隨：',
                            line1: '位於樑架之上、相鄰的兩根檁條之間起聯繫作用的彎月形的彎枋構件，閩南稱“束木”、“束仔”、“彎弓”、“水尾”、“彎插”、“蝦尾插”。',
                            line2: '束木由宋式的“劄牵”演化而来劄牵是长一椽、起联系作用的梁。',
                        },
                        type8: {
                            exp: '彎枋、連栱：',
                            line1: '閩南古建築中，聯繫左右兩縫樑架的縱架系統的組件除內額、副檁、順脊串、順身串、襻間外，還有以彎枋、連栱等構成的組件，稱為“看架”、“排架”。看架用於前後金柱間，是由古代的扶壁栱和縱架發展而來的構架形式。中國南方的宋代建築如福州市華林寺大殿、浙江寧波保國寺大殿、莆田市玄妙觀三清殿等，其扶壁栱都是以令栱承托柱頭枋為一組，逐層重疊，直抵榑下。而北方同期建築則在泥道栱上用多層柱頭枋構成井乾式的槽，僅在枋上隱刻出栱身。這種單栱素枋交替重疊的做法常見於敦煌壁畫中，應是中唐以前的舊法遺存在南方的。',
                            line2: '在民居、宗祠與廟宇中，看架用鬥栱及彎枋、素枋等層疊組合，一般的做法是在門眉、壽梁或枋之上，置二、四或六個座鬥（沒有一、三或五個座鬥的做法），鬥兩側施以鬥抱（鬥座），鬥之上施左右相連的彎枋，其上再承託一斗三升（三星供）、素枋等再上為圓引，直至圓仔下，以像徵二朵、四朵、六朵補間鋪作。',
                            line3: '泉州市開元寺天王殿看架的構成是，在左右金柱（閩南稱青柱）間施“內額”（閩南稱眉），其上施座鬥、鬥抱兩枚，上承彎枋，再上為一斗六升（座斗上承兩個三星栱）承素枋，再重疊一層一斗六升與素枋，直抵金檁（青圓）之下。'
                        },
                        type9: {
                            exp: '圓：',
                            line1: '闽南称檩条为圆、圆仔、楹木、楹丁、桁木。',
                            line2: '泉州市開元寺天王殿看架的構成是，在左右金柱（閩南稱青柱）間施“內額”（閩南稱眉），其上施座鬥、鬥抱兩枚，上承彎枋，再上為一斗六升（座斗上承兩個三星栱）承素枋，再重疊一層一斗六升與素枋，直抵金檁（青圓）之下。',
                        },
                        type10: {
                            exp: '桷：',
                            line1: '閩南稱椽為桷、桷仔、桷枝。 “桷”是椽子的古稱。 《詩・魯頌・閟宮》：“松桷有舄，路寢孔碩。”鄭箋：“桷，榱也。舄，大貌。路寢，正寢也。”孔疏：“桷之與榱，是椽之別名。《莊二十四年》刻桓宮桷，謂刻其椽也。舄是桷狀，故為大貌。”《榖梁傳・莊公二十四年》：“刻桓宮桷。禮，天子之桷，斫之礱之。加密石焉。諸侯之桷，斫之礱之。大夫斫之。士斫本。刻桷，非正也。”刻桷，即在桷上刻上裝飾。 《說文・木部》：“榱，桷也。秦名屋榱也，周渭之椽，齊魯謂之桷。”唐韓愈《進學解》：“夫大木為杗，細木為桷，欂櫨侏儒，椳闑扂楔，各得其宜，施以成室者，匠氏之工也。”唐陸德明《經典釋文》曰：“椽，榱也，圓曰椽，方曰桷。”《營造法式》卷二“總釋下・椽”引《說文》：“椽方曰桷。”又引唐陸德明《春秋左傳音義》曰：“圜曰椽。”可知桷特指方椽，閩南傳統建築中用椽都是方椽，沒有用圓椽的。',
                            line2: '閩南用的方椽，並不是斷面正方形的椽子。其斷面為高寬比1/4左右的扁方形，故乂稱“桷仔板”、“板條”，與宋代以來官式建築中的方椽、圓椽不同。',
                        },
                        type11: {
                            exp: '鬥：',
                            line1: '鬥是位於栱、昂、枋間的、“鬥”狀的墊托構件，在閩南稱“鬥仔”。',
                            line2: '閩南用的方椽，並不是斷面正方形的椽子。其斷面為高寬比1/鬥的種類：',
                            line3_title: '閩南傳統建築中的鬥，依外形區分,有以下幾種：',
                            line3_1: '（1）方鬥，平面方形，又稱為四方鬥。閩南宋、元、明代建築中鬥皆作此式。',
                            line3_2: '（2）圓鬥，平面圓形的鬥。有的圓鬥，立面不再區分耳、平和欹，整體形狀猶如一隻碗，又稱為碗仔鬥、碗公鬥。',
                            line3_3: '（3）六角斗，平面六角形，又稱為六閣鬥。',
                            line3_4: '（4）八角斗，平面八角形，又稱為八閣鬥。六角斗、八角斗多用於雞舌栱、藻井之中。',
                            line3_5: '（5）訛角斗，方鬥四角卷殺成圓弧形。',
                            line3_6: '（6）海棠鬥，將訛角斗的四角刻出窩角曲線，平面如海棠形。閩南明代及清初的石坊如漳州市“尚書、探花”坊（1605）、“三世宰貳、兩京揚歷”坊（1619）、泉州市施琅神道碑亭（1697）、漳州市“勇壯簡易、所向無前”坊（1707）、泉州市“急公尚義”坊（1715）、廈門市“績光銅柱、思永峴碑”坊（1717）、漳州市“閩越雄聲、楚滇偉績”坊（1722）等，將鬥欹四角刻成海棠曲線或抹斜，以與下面的海棠線腳或抹角方柱對應。江浙地區的宋元建築如江蘇省蘇州市雲巖寺塔、東山縣軒轅官正殿、蘇州市虎丘雲巖寺二山門、浙江省寧波市保國寺大殿等，海棠鬥的運用已較為普遍。而在福建的宋元建築中則未見使用。海棠鬥於明代出現後，廣泛用於閩南的寺觀、祠堂、大厝之中。',
                            line3_7: '（7）梅花鬥，平面圓形並分成數瓣，如梅花形。瓜筒上的瓜頭鬥多用之。',
                            line3_8: '（8）蓮鬥，平面圓形，做成仰蓮形。福建蓮鬥的實例，以1959年發現但於兩年後毀去的泰宁甘露庵的上殿、觀音閣、南安閣這三座南宋建築為最早，蓮鬥用於柱斗上的櫨鬥。現存實物則以石獅市金釵山六勝塔［元後至元二年（1336）］為最早，用於每層角柱的櫨鬥。',
                            line3_9_title_line1: '泉州市開元寺大雄寶殿、泉州府文廟大成殿中都使用蓮形櫨鬥。蓮鬥表面一般都施彩畫，用“化色”渲染出蓮瓣的色調和層次。',
                            line3_9_title_line2: '依位置區分，鬥有以下諸式：',
                            line3_9_1: '（1）柱頭鬥，用於柱頭上的圓鬥、方鬥或梅花鬥，直徑（斜徑）與柱子直徑相等，經常與柱子連做。',
                            line3_9_2: '（2）瓜頭鬥，用於瓜筒之上的方鬥或圓鬥，邊長或直徑與瓜筒相等，鬥底往往有四個卯洞，以便套住瓜筒上的四個凸榫。有的瓜頭鬥直接從瓜筒上雕出。',
                            line3_9_3: '（3）栱尾鬥，栱端的散鬥或交互鬥。',
                            line3_9_4: '（4）雞舌鬥，用於雞舌栱之下。',
                            line3_9_5: '（5）寮鬥，用於寮圓（挑簷檁）雞舌栱下的鬥，工匠俗寫為“遼鬥”。',
                            line3_9_6: '（6）連栱尾鬥，也稱“連栱鬥”，用於連栱（鴛鴦交首栱）之上。',
                        },
                        type12: {
                            exp: '栱：',
                            line1: '閩南傳統建築中的栱，按其位置及功能有出跳的“栱仔”、兩栱頭相連共承一斗的‘’連栱”等；按其外形區分則有關刀栱、葫蘆栱、螭虎栱、雞舌栱、飛天栱、龍頭栱、象鼻栱、鳳首栱、三星栱、瓜串等，其中以關刀栱、葫蘆栱、螭虎栱使用最為廣泛；按結構方式區分，有自斗口中出跳的栱與插入柱身的插栱。斜栱在清代晚期才出現，使用極少。',
                            line2: '栱形特徵：',
                            line3: '宋代以來的官式建築中．栱頭曲線使用分瓣卷殺的方式進行加工。福建宋元時期的木構建築和石鉤建築，如福州市華林寺大殿、泉州市開元寺雙石塔、清源山彌陀岩、石獅市六勝塔、順昌寶山寺石殿等，其栱頭曲線末分瓣，而是呈現圓滑的弧線；只有莆田市玄妙觀三清殿的栱頭分成數瓣卷殺，有的且內䫜。',
                            line4: '宋《營造法式》卷四“大木作制度一・栱”規定栱眼做法：“栱兩頭及中心，各留坐鬥處，餘並為栱眼，深三份。如用足材栱，則更加一栔，隱出心枓及栱眼。”福建的三座宋代木構建築——福州市華林寺殿、莆田市玄妙觀三清殿、羅源陳太尉官正殿，將栱眼的上棱抹斜，使栱眼呈現兩頭尖細的葵花仔殼形，抹斜時外淺而內深，造成栱頭上翹的視錯覺。這種處理未見於同期的江南、嶺南建築中，是福建宋代建築的地方手法。'
                        },
                    },
                },
                ll_chird: {
                    firstQ: {
                        question: '1.通常情況下，我國傳統木構架各構件連接所採用形式為？',
                        option: {
                            A: 'A.榫卯',
                            B: 'B.鉸接',
                            C: 'C.綁紮',
                            D: 'D.採用鐵釘釘牢'
                        }
                    },
                    secondQ: {
                        question: '2.下列不屬於閩南傳統木構架地方術語的是？',
                        option: {
                            A: 'A.圓子',
                            B: 'B.瓜筒',
                            C: 'C.大通',
                            D: 'D.垂花門'
                        }
                    }
                }
            },
            three: {
                zs: '知識學習',
                ll: '理論測試',
                jh: '交互訓練',
                zs_child: {
                    line1: '閩南傳統建築使用的結構以插樑式構架與承重牆的混合體係為主。',
                    line2: '緊密結合地域特色的建築材料是閩南傳統建築牆體的重要特徵。閩南傳統建築使用當地特色紅磚、蠣殼灰、條石等特殊材料，形成了別具一格的建築風格形式。',
                    line3: '閩南紅磚又統稱為“煙炙磚”，煙炙磚的製造工藝複雜。首先挑選原材料，用稻田中的泥土做磚坯。燒製紅磚的土要比青磚的質量要求高，"土質好的可燒成紅色磚瓦;土質差的，會成重灰色;如要燒成紅色，土質差的須以好土蓋磚面或兩個邊，以便成品有光面和紅色。好的蓋面土價為普通土的五倍"。其次是入窯焙燒。磚坯入窯燒製時側立斜向堆碼，以鬆枝為主要燃料。松枝灰燼落在磚坯相疊的露空部位， 在朝上的一面熏成黑色斜斑紋。而在碼窯時磚坯的排列不盡整齊，故黑斑紋的方向、位置、寬窄不一。但由於上下兩磚相疊，兩條黑斑紋之間的紅紋的寬度一定與磚的厚度相等，而且在磚的6 個面中，只有朝上的這一面才有黑紅相間的紋路。煙炙磚色澤艷麗，規格平整，質地極佳，紅磚表面有二三道紫黑色紋理。',
                    line4: '蠣殼灰，用蠣殼、蚌殼等燒成的白灰，古稱“蜃灰”。 《考工記》∶"燒蜃灰堊牆。"是用貝殼燒成的石灰，在春秋戰國時就已為人們所認識。',
                    line5: '《天工開物》還詳細記述了蝠殼的產生與蝸灰的燒製過程：',
                    line6: '凡海濱石山傍水處，咸浪積壓，生出蠣房，閩間中日蠔房。經年久者，長成數丈，闊則數畝，崎嶇如石假山形象。蛤之類壓入岩中，久則消化作肉團，名曰蠣黃，味極珍美。凡燔蠣灰者，執椎與鑿，濡足取來（藥舖所貨牡蠣，即此碎塊），疊煤架火燔成，與前石灰共法。粘砌城牆、橋樑，調和桐油造舟，功皆相同。有誤以蜆灰（即蛤粉）為蠣灰者，不格物之故也。',
                    line7: '早在北宋時、蔡襄造泉州洛陽萬安橋就用了蠣殼灰。',
                    line8: '用牡蠣殼燒成的殼灰也稱為"蛔殼灰"、"大殼灰"。蠣殼灰精緻細膩，閩南傳統建築中高超的紅磚組砌技術與這種黏結材料是分不開的。',
                    type1: {
                        exp: '石料：',
                        line1: '閩南地區盛產優質花崗岩，常見有青石、白石、黑石等種類。主要用於牆體的基礎，對看堵、鏡面牆的身堵、裙堵、腰堵、櫃檯腳，山牆以及石景、門框和窗等。'
                    },
                    type2: {
                        exp: '牆身砌築的類型：',
                        line1: '閩南沿海一帶屬於“紅磚文化區”，其牆身磚作的類型較為豐富，除了常見勾縫形式的變化，還有磚的排列和組砌形式的差異。',
                        line2: '（1）按構造類型分類',
                        line3: '磚的砌築方法主要有封磚壁和出磚入石，此外還有土牆、石牆、牡蝸殼牆和桿真牆等採用不同材料製成的牆體。',
                        line4: '外側磚的砌築組合方式有多種，包括平砌、鬥仔砌和花磚組砌等。',
                        line5: '平砌，即逐層順磚砌築，工字縫。在官式中，這種砌法也稱“十字縫”。由於沒有丁磚與內層拉結，這種方式很容易造成內外分離。',
                        line6: '拼花磚，其組砌形式千變萬化，裝飾性很強，形成的圖案包括卍字、古錢花等，在角牌和中牌也常見用拼花磚組成的文字。'
                    }
                },
                ll_child: {
                    firstQ: {
                        question: '1.下列不屬於閩南傳統建築的牆體名稱的是？',
                        option: {
                            A: 'A.對看堵',
                            B: 'B.鏡面堵',
                            C: 'C.規帶',
                            D: 'D.水車堵'
                        }
                    },
                    secondQ: {
                        question: '2.下列不屬於閩南傳統建築牆體材料的是？',
                        option: {
                            A: 'A.花崗岩石材',
                            B: 'B.白色瓷磚',
                            C: 'C.煙炙磚',
                            D: 'D.牡蠣殼灰'
                        }
                    }
                }
            },
            four: {
                zs: '知識學習',
                ll: '理論測試',
                jh: '交互訓練',
                zs_child: {
                    first: {
                        type1: {
                            exp: '1、材料',
                            line1: '閩南沿海地區傳統建築的院落和室內通常都有磚石鋪裝。室內地面多用紅磚，有方磚、條磚和六角磚等形式，宮觀祠廟中還會以條石或者紅磚形成各個開間的分隔帶；室外的前埕和深井等常用條石或紅磚鋪地。',
                            line2: '（1）磚',
                            line3: '紅磚是閩南沿海地區傳統建築的主要地面材料。在近代洋樓建築中，也有使用彩色地磚的方式，其色彩素雅，圖案精美，但在閩南傳統閩南古厝建築中少見。',
                            line4: '己有諸多學者對閩南紅磚的傳統燒製技藝進行了研究。目前仍有部分地方還在燒製生產傳統紅磚，主要用於古建築的修繕和新建傳統式樣建築，雖然磚坯已經採用機器製作，但燒製過程仍為傳統工藝，據晉江蘇厝磚廠的師傅講述，窯內溫度在1000℃左右，整個製作週期較為漫長，大致需要三到四個月。',
                            line5: '不同的磚料有著不同的用途，如方磚多用於民居和宮觀祠廟的室內地面，六角磚常見於部分宮觀祠廟中，條磚則主要用於院落和深井的鋪裝。'
                        },
                        type2: {
                            exp: '方磚：',
                            line1: '方磚以紅色為主，看面邊長在210—50Omm間，厚度在20—30mm間。其中，“尺二磚”較為常見。廈門傳統營造尺為29.40cm，泉州為30.00cm，“尺二”即邊長一尺二寸，約360mm。閩南地區只有邊長為360mm的方磚有“尺二磚”的專用術語，其他尺寸尚無確切稱呼。'
                        },
                        type3: {
                            exp: '條磚：',
                            line1: '用於鋪地的條磚看面短邊長在95—180mm間，長度在185-280mm間，厚度約為20-30mm，以紅磚為主。',
                            line2: '（2）石',
                            line3: '花崗岩條石：',
                            line4: '閩南地區盛產石材，特別是優良的白色花崗岩。花崗岩條石露明面通常由石匠打鑿成荔枝面，工匠稱之為“兩遍齊”，其他面均為自然面，便於和土層較為緊密的結合。截面寬度為270—30Omm，厚度為150mm，條石長度根據現場需要而定。'
                        }
                    },
                    second: {
                        type1: {
                            exp: '2、磚地面',
                            line1: '從磚的排列形式上，可分為以下幾種：'
                        }
                    }
                },
                ll_child: {
                    firstQ: {
                        question: '1.閩南傳統地面所用材料不包括下列哪種？',
                        options: {
                            A: 'A.紅色鬥底磚',
                            B: 'B.石灰混合砂漿',
                            C: 'C.花崗岩條石',
                            D: 'D.水刷石'
                        }
                    },
                    secondQ: {
                        question: '2.閩南傳統地面施工工序描述錯誤的是？',
                        options: {
                            A: 'A.施工前要將地磚浸水一段時間',
                            B: 'B.施工時，要先拉線輔助，然後再鋪磚',
                            C: 'C.施工時，鋪磚的勾縫可以邊鋪磚邊勾縫',
                            D: 'D.勾縫的作用除了美觀之外，還可以調節紅磚尺寸的誤差'
                        }
                    }
                }
            }
        },
    },
    mn: {
        zs: '知識學習',
        ll: '理論測試',
        jh: '交互訓練',
        ll_child: {
            dialog: {
                tip: '您尚未完成XXX模塊的理論測試（交互訓練），是否仍要離開?',
                yes: '是',
                no: '否'
            },
            firstQ: {
                question: '1.下列材料不屬於閩南傳統建築材料的是？',
                option: {
                    A: 'A.煙炙磚',
                    B: 'B.杉木',
                    C: 'C.海蠣殼灰',
                    D: 'D.水泥'
                }
            },
            secondQ: {
                question: '2.下列對閩南特有的煙炙磚的說明錯誤的是？',
                option: {
                    A: 'A.煙炙磚又稱為胭脂磚',
                    B: 'B.煙炙磚是我國古代青磚的一種',
                    C: 'C.煙炙磚是閩南地區特色建築材料，它是紅磚的一種',
                    D: 'D.煙炙磚是在燒製過程中，松枝灰落在磚坯相疊的露空部位，熏出黑色斜紋而形成的'
                }
            },
            thirdQ: {
                question: '3.在閩南，“出磚入石”是牆面的一種藝術表現形式，其含義指的是？',
                option: {
                    A: 'A.砌牆時，磚砌在石頭基礎的上面',
                    B: 'B.砌牆時，磚作為外牆材料，石材作為內牆材料',
                    C: 'C.砌牆時，磚與大小不一的石材混用，形成極具變化的牆體',
                    D: 'D.牆體中，磚要突出於石材'
                }
            },
            fourthQ: {
                question: '4.閩南古代傳統建築中，室內地面不會採用的材料為？',
                option: {
                    A: 'A.紅色鬥底磚',
                    B: 'B.木板條',
                    C: 'C.條石',
                    D: 'D.水磨石'
                }
            }
        }
    },
    kh: {
        choiceQuestion: {
            start: '開始',
            sub: '提交',
            title: '理論考核',
            firstQ_title: '一.選擇題',
            firstQ_title_tip: '（包含單选和多選題，請謹慎答題）',
            type1: {
                question: '1.泉州天后宮正殿天后殿的屋頂形式是什麼？',
                options: {
                    A: 'A.廡殿頂',
                    B: 'B.歇山頂',
                    C: 'C.硬山頂',
                    D: 'D.懸山頂'
                }
            },
            type2: {
                question: '2.泉州天后宮始建於什麼朝代？',
                options: {
                    A: 'A.漢朝',
                    B: 'B.唐朝',
                    C: 'C.宋朝',
                    D: 'D.明朝'
                }
            },
            type3: {
                question: '3.媽祖信仰的起源地是哪裡？',
                options: {
                    A: 'A.莆田',
                    B: 'B.泉州',
                    C: 'C.福州',
                    D: 'D.廈門'
                }
            },
            type4: {
                question: '4.泉州天后宮正殿天后殿的是幾開間建築？',
                options: {
                    A: 'A.三開間',
                    B: 'B.五開間',
                    C: 'C.七開間',
                    D: 'D.九開間'
                }
            },
            type5: {
                question: '5.常見的閩南傳統建築牆體材料為？',
                options: {
                    A: 'A.鬥底磚',
                    B: 'B.煙炙磚 ',
                    C: 'C.青磚',
                    D: 'D.混凝土'
                }
            },
            type6: {
                question: '6.閩南傳統建築抹灰材料主要為？',
                options: {
                    A: 'A.殼灰砂漿',
                    B: 'B.水泥砂漿 ',
                    C: 'C.石膏砂漿',
                    D: 'D.以上都是'
                }
            },
            type7: {
                question: '7.閩南傳統建築地面鋪裝的主要材料為？ （多選）',
                options: {
                    A: 'A.鬥底磚',
                    B: 'B.水泥磚 ',
                    C: 'C.大理石磚',
                    D: 'D.花崗岩條石'
                }
            },
            type8: {
                question: '8.下列不屬於閩南傳統建築屋面材料的是？',
                options: {
                    A: 'A.瓦',
                    B: 'B.望板 ',
                    C: 'C.望磚',
                    D: 'D.鬥底磚'
                }
            },
            type9: {
                question: '9.閩南傳統建築兩側廂房的特有地域性名稱是？',
                options: {
                    A: 'A.下房',
                    B: 'B.下落 ',
                    C: 'C.櫸頭',
                    D: 'D.前埕'
                }
            },
            type10: {
                question: '10.泉州天后宮被冊封的朝代為？',
                options: {
                    A: 'A.明朝',
                    B: 'B.元朝 ',
                    C: 'C.宋朝',
                    D: 'D.唐朝'
                }
            }
        },
        dialog: {
            title: '考核成績',
            singleChoice: '選擇題',
            multipleChoice: '多選題',
            answer_right: '答題正確',
            anser_wrong: '回答錯誤',
            score: '考核得分：',
            Company: '分',
            continue: '繼續考核',
            result: '理論考核已完成，將進入交互考核環節！',
            start: '立即開始'
        }
    },
    sy: {
        title: '實驗報告',
        submit: '提交',
        type1: {
            title: '一.實驗目的'
        },
        type2: {
            title: '二.實驗過程'
        },
        type3: {
            title: '三.心得體會'
        }
    },
    title: {
        "考核测试": "考核測試",
        "实验报告": "實驗報告",
        "天后宫空间布局": "天后宮空間佈局",
        "妈祖信仰与泉州天后宫": "媽祖信仰與泉州天后宮",
        "妈祖信仰海外传播": "媽祖信仰海外傳播",
        "传统建筑设计与构造教学": "傳統建築設計與構造教學",
        "闽南侨乡传统建筑构造": "閩南僑鄉傳統建築構造",
        "各部位做法工序": "各部位做法工序",
        "传统屋面": "傳統屋面",
        "传统木架构": "傳統木架構",
        "传统地面": "傳統地面",
        "传统墙体": "傳統牆體",
        "闽南侨乡传统建筑修缮训练": "閩南僑鄉傳統建築修繕訓練",
        "中华建筑文化海外传播虚拟仿真实验": "中華建築文化海外傳播虛擬仿真實驗"
    },
    external: {
        logoTitle: {
            "华侨大学建筑学院": " 華僑大學建築學院 ",
            "虚拟仿真实验申报管理平台": "虛擬仿真實驗申報管理平台"
        },
        login: {
            "登录": "登錄",
            "请输入手机号/用户名/邮箱": "請輸入手機號/用戶名/郵箱",
            "请输入6-11位密码": "請輸入6-11位密碼",
            "点击图片输入验证码": "點擊圖片輸入驗證碼",
            "学生": "學生",
            "评审": "評審",
            "立即登录": "立即登錄",
            "忘记密码?": "忘記密碼?",
            "请输入验证码": "請輸入驗證碼",
            "长度在6到11个字符": "長度在 6 到 11 個字符",
            '登录成功！': '登錄成功！'
        },
        register: {
            "注册": "註冊",
            "请输入手机号/邮箱": "請輸入手機號/郵箱",
            "请输入6-11位密码": "請輸入6-11位密碼",
            "请再次输入密码": "請再次輸入密碼",
            "请输入验证码": "請輸入驗證碼",
            "获取验证码": "獲取驗證碼 ",
            "立即注册": "立即註冊",
            "请输入密码": "請輸入密碼",
            "请再次输入密码": "請再次輸入密碼",
            "两次输入密码不一致!": "兩次輸入密碼不一致!",
            "长度在6到11个字符": "長度在 6 到 11 個字符",
            "请输入验证码": "請輸入驗證碼",
            "请输入验证码": "請輸入驗證碼",
            "注册成功！": "註冊成功！",
            "发送成功！": "發送成功！",
        },
        header: {
            "首页": "首頁",
            "中心概况": "中心概況",
            "师资队伍": "師資隊伍",
            "仿真实验": "仿真實驗",
            "建筑作品": "建築作品",
            "动态新闻": "動態新聞",
            "校企合作": "校企合作",
            "教学成果": "教學成果",
        },
        home: {
            "作品推荐": "作品推薦",
            "更多作品": "更多作品",
            "动态新闻": "動態新聞",
            "更多新闻": "更多新闻",
        },
        zxgk: {
            "中心简介": "中心簡介",
            "组织结构": "組織結構",
            "发展历程": "發展歷程",
            "规章制度": "規章制度",
            "建设成果": "建設成果",
            "您当前的位置:平台首页>中心概况>": "您當前的位置：平台首頁 > 中心概況 >",
            "返回": "返回",
            "正文": "正文",

        },
        szdw: {
            "师资队伍": "師資隊伍"
        },
        fzsy: {
            "全部分类": "全部分類",
            "建筑学": "建築學",
            "暂无数据！": "暫無數據！",
            "城乡规划": "城鄉規劃",
            "请选择": "請選擇",
            "风景园林": "風景園林",
            "建筑遗产保护技术": "建築遺產保護技術",
            "人居环境科学与技术": "人居環境科學與技術",
            content: {
                header: {
                    "项目首页": "項目首頁",
                    "项目团队": "項目團隊",
                    "项目描述": "項目描述",
                    "网络要求": "網絡要求",
                    "技术架构": "技術架構",
                    "项目特色": "項目特色",
                    "服务计划": "服務計劃",
                    "知识产权": "知識產權",
                    "附件材料": "附件材料",
                    "实验指南": "實驗指南",
                    "承诺意见": "承諾意見"
                },
                home: {
                    "中华建筑文化海外传播虚拟仿真实验": "中華建築文化海外傳播虛擬仿真實驗",
                    "项目简介视频": " 項目簡介視頻 ",
                    "项目引导视频": " 項目引導視頻 ",
                    "所属专业：": " 所屬專業：",
                    "对应专业：": "對應專業：",
                    "建筑类": "建築類",
                    "建筑学": "建築學",
                    "负责人：": "負責人：",
                    "陈志宏": "陳志宏",
                    "本项目以闽南传统侨乡建筑的代表泉州天后宫为案例，对其妈祖信仰、建筑空间进行知识点传授，接着利用虚拟仿真技术具有的真实性、模拟性的特点，对营造技艺、修缮复原施工过程进行虚拟还原，让学生在虚拟的环境下进行技艺的学习，亲身体会修缮复原的操作。": "本項目以閩南傳統僑鄉建築的代表泉州天后宮為案例，對其媽祖信仰、建築空間進行知識點傳授，接著利用虛擬仿真技術具有的真實性、模擬性的特點，對營造技藝、修繕復原施工過程進行虛擬還原，讓學生在虛擬的環境下進行技藝的學習，親身體會修繕復原的操作。",
                    "开始实验": "開始實驗",
                    "项目简介": "項目簡介",
                    "引导视频": "引導視頻",
                    "问题交流": "問題交流",
                    "常见问题": "常見問題",
                    "请输入问题内容": "請輸入問題內容...",
                    "提交问题": "提交問題",
                    "最新问题": "最新問題",
                    "请先登录": "最新問題",
                    "上一页": "上一頁",
                    "下一页": " 下一頁",
                    "请输入关键字，点击搜索按钮进行搜索...": "請輸入關鍵字，點擊搜索按鈕進行搜索...",
                    "常见问题": "常見問題",
                    "实验评价": "實驗評價",
                    "请输入评价内容": "請輸入評價內容...",
                    "提交评价": "提交評價",
                    "使用情况": "使用情況",
                    "实验人数": "實驗人數",
                    "实验次数": "實驗次數",
                    "实验评价": "實驗評價",
                    "实验评价：": "實驗評價：",
                    "人评分": "人評分",
                    "请先登录！": "請先登錄！",
                    "评论内容不能为空！": "評論內容不能為空！",
                    "评论失败": "評論失敗",
                    "评论成功": "評論成功"
                },
                xmtd: {
                    "项目描述": "項目描述",
                    "您当前的位置：": "您當前的位置：",
                    "项目首页": "項目首頁",
                    ">项目描述": ">項目描述",
                    "正文": "正文 "
                }
            }
        },
        personal: {
            "当前位置：个人中心": "當前位置：個人中心",
            head: {
                "更换头像": "更換頭像",
                "上传图片": "更換頭像",
                "确认修改": "確認修改"
            },
            nav: {
                "实验成绩": "實驗成績",
                "实验报告": "實驗報告",
                "我的作品": "我的作品",
                "已学课程": "已學課程",
                "我的问题": "我的問題",
                "个人信息": "個人信息",
                "账号安全": "賬號安全",
            },
            content: {
                one: {
                    "实验成绩": "實驗成績",
                    "返回": "返回",
                    "序号": "序號",
                    "实验名称": "實驗名稱",
                    "训练时长": "訓練時長",
                    "完成时间": "完成時間",
                    "步骤得分": "步驟得分",
                    "报告得分": "報告得分",
                    "操作": "操作",
                    "成绩详情": "成績詳情",
                    "查看步骤": "查看步驟",
                    "排行榜": "排行榜",
                    "虚拟实验：": "虛擬實驗：",
                    "耗时：": "耗時：",
                    "总分：": "總分：",
                    "序号": "序號",
                    "排名": "排名",
                    "排名：": "排名：",
                    "查看": "查看",
                    "姓名": "姓名",
                    "耗时": "耗時",
                    "花费时间": "花費時間",
                    "分数": "分數"
                },
                two: {
                    "实验报告": "實驗報告",
                    "序号": "序號",
                    "实验名称": "實驗名稱",
                    "分数": "分數",
                    "批改": "批改",
                    "已批改": "已批改",
                    "未批改": "未批改",
                    "操作": "操作",
                    "返回": "返回",
                    "姓名：": "姓名：",
                    "学号：": "學號：",
                    "查看报告": "查看報告",
                    "实验目的：": "1、實驗目的：",
                    "请输入内容": "請輸入內容",
                    "实验过程：": "2、實驗過程",
                    "心得体会": "3、心得體會",
                    "提交": "提交",
                    "教师评价：": "教師評價：",
                    "教师评分：": "教師評分：",

                },
                three: {
                    "我的作品": "我的作品",
                    "创建": "創建",
                    "查看": "查看",
                    "编辑": "編輯",
                    "删除": "删除",
                    "取消": "取消",
                    "暂无作品": "暫無作品",
                    "删除作品": "删除作品",
                    "删除作品将无法找回，请慎重操作！": "刪除作品將無法找回，請慎重操作！",
                    "删除成功！": "删除成功！",
                },
                four: {
                    "已学课程": "已學課程",
                    "序号": "序號",
                    "实验名称": "實驗名稱",
                    "时长": "時長",
                    "操作": "操作",
                    "继续学习": "繼續學習",
                    "重新学习": "重新學習",
                    "暂无数据": "暫無數據"
                },
                five: {
                    "我的问题": "我的問題",
                    "暂无数据！": "暫無數據！",
                },
                six: {
                    "个人信息": "個人信息",
                    "姓名": "姓名",
                    "请输入姓名": "請輸入姓名",
                    "性别": "性别",
                    "学号": "學號",
                    "请输入学号": "請輸入學號",
                    "班级": "班級",
                    "请输入班级": "請輸入班級",
                    "保存": "保存",
                    "退出登录": "退出登錄",
                    "长度在2到16个字符": "長度在 2 到 16個字符",
                    "请输入学号": "請輸入學號",
                    "请输入班级": "請輸入班級",
                    "男": "男",
                    "女": "女",
                    "是否退出登录?": "是否退出登錄?",
                    "提示": "提示",
                    "确定": "确定",
                    "取消": "取消"
                },
                seven: {
                    "账号安全": "賬號安全",
                    "修改密码": "修改密碼",
                    "旧密码": "舊密碼",
                    "设置密码": "設置密碼",
                    "再次输入密码": "再次輸入密碼",
                    "保存": "保存",
                    "请输入密码": "請輸入密碼",
                    "请再次输入密码": "請再次輸入密碼",
                    "请输入旧密码": "請輸入舊密碼",
                    "两次输入密码不一致!": "兩次輸入密碼不一致!",
                    "请再次输入密码": "請再次輸入密碼",
                }
            }
        }
    }
}